export default "__VITE_ASSET__BG24zWp7__"